// Original fortune-cookie lines, drawn at random without repeats until the bag empties.
export const FORTUNES: readonly string[] = [
  'The thing you keep poking at will give way sooner than you think.',
  'Good things stretch a little before they snap into place.',
  'You can hold far more than you think before you burst.',
  'Someone is about to take you less seriously, in the best way.',
  'Pressure is only air that hasn’t found the door yet.',
  'Every ending makes a small, satisfying sound.',
  'A small wobble today saves a big tumble tomorrow.',
  'The answer is closer to the edge than you expect.',
  'You will soon be exactly as round as you need to be.',
  'Somebody is saving the last dumpling for you.',
  'Your next mistake will teach you something delicious.',
  'Stretch before you decide. Then decide quickly.',
  'Luck is mostly showing up and pulling a little harder.',
  'A friend will laugh at your joke a second too late. It still counts.',
  'Soft things last longer than you think.',
  'You are one good nap away from a great idea.',
  'What you are looking for is in the second place you check.',
  'Bounce back, but keep a little of the dent.',
  'Today, say yes to the smaller plate and the bigger dessert.',
  'Your patience is about to pay out in small coins of joy.',
  'The quiet person in the room agrees with you.',
  'Something you lost will turn up in a coat pocket.',
  'Pop the question you have been holding in your cheeks.',
  'You will learn a word today and use it by Friday.',
  'The best view is on the other side of an awkward climb.',
  'Do the dull thing first; the fun thing tastes better after.',
  'A tiny kindness will come back wearing a hat.',
  'Not every bubble needs popping. This one did.',
  'Your hands already know how to do the hard part.',
  'An old song will find you right when you need it.',
  'Tomorrow’s forecast: mostly you, with a chance of brilliance.',
  'Take the long way home once this week.',
  'The door you pushed was a pull. Try again.',
  'You will be early for something important.',
  'Be the calm in someone else’s wobble.',
  'Your plans are fine. Your snacks could be better.',
  'A stranger will hold a door and your whole day will tilt upward.',
  'Curiosity is the only map that never goes out of date.',
  'Leave one thing unfinished on purpose. It keeps you coming back.',
  'The loudest pop comes from the smallest pin.',
  'You already did the brave part by starting.',
  'Water the plant. Text the friend. Drink some water yourself.',
  'Something wonderful is taking its time. Let it.',
  'Say it in fewer words and it will travel further.',
  'You are allowed to change your mind mid-bounce.',
  'Your next good idea will arrive in the shower. Keep a pen nearby.',
  'A shortcut you find this month becomes a habit for life.',
  'Your laugh is someone’s favourite sound.',
  'Fold the map wrong. You will still get there.',
  'Big luck arrives in small change. Keep your pockets open.',
  'The recipe works better with a second pinch of courage.',
  'Today is a good day to fix the squeaky thing.',
  'Someone admires the way you keep trying.',
  'Rest is not the opposite of progress.',
  'Ask the question. The worst answer is a shrug.',
  'A new friend is hiding inside an old acquaintance.',
  'You will find a coin, a feather, or a better word.',
  'The long queue is where the good conversation starts.',
  'A mistake made twice is a pattern. Make it a dance.',
  'Your future self is already grateful for tonight’s sleep.',
  'Keep your elbows soft and your goals firm.',
  'Treat worries like bubbles: look closely, then let them drift.',
  'Someone is about to ask for your advice. Keep it short.',
  'You will hear good news before lunch on a Thursday.',
  'A warm drink will solve at least half of it.',
  'Say thank you in a language you are still learning.',
  'Your best work happens right after you put the phone down.',
  'You will make someone laugh without meaning to.',
  'An unexpected detour leads to an excellent sandwich.',
  'The courage you need fits in one deep breath.',
  'Tidy one drawer and your whole mind gets lighter.',
  'A plan written on a napkin is still a plan.',
  'The smallest step still leaves a footprint.',
  'You are more flexible than yesterday’s version of you.',
  'The best surprise this week will cost nothing.',
  'Let someone else pick the music. You will like it.',
  'Every expert once pulled toward the wrong edge too.',
  'Your luck improves a little with every honest word.',
  'Somebody far away is thinking of you fondly right now.',
  'When in doubt, add more air and try again.',
  'Good news takes the scenic route. It will still arrive.',
  'A walk will fix what the screen cannot.',
  'You will finally understand a joke you heard years ago.',
  'The thing you were dreading will take eleven minutes.',
  'Keep going. The middle always feels the stretchiest.',
  'Wear the good socks. Today counts.',
  'Someone you helped quietly is about to return the favour.',
  'A little silliness makes serious things easier to carry.',
  'Your idea is ripe. Pick it before it wobbles off the branch.',
  'Learn one character a day and you will read a menu by spring.',
  'You will be the reason someone keeps a photo.',
  'Hold on lightly. Pull with purpose. Let go on time.',
  'The best time to start was earlier. The second best is this bubble.',
  'A clear head is waiting at the bottom of your to-do list.',
  'A door will open. Probably the fridge. Enjoy it anyway.',
  'You are allowed to be proud of small things.',
  'The next page is better than the last one.',
  'What goes pop comes back as something new.',
  'You will remember this word longer than you expect.',
  'Luck favours those who stretch toward the edge.'
];
